import { IAgriAlertTranslateResModel } from '@/util/Request/agrialert/responseType';

export const sprayOptions = [
    {
        'code': 'sw_aerialspraygeneric',
        'name': 'Aerial Spray Generic'
    },
    {
        'code': 'sw_groundspraygeneric',
        'name': 'Ground Spraying'
    },
    {
        'code': 'sw_ground_frcp01',
        'name': 'Ground Spraying Fungicide in France'
    },
    {
        'code': 'sw_aerialspray_aus',
        'name': 'Aerial Spray Australia'
    },
    {
        'code': 'sw_groundspray_aus',
        'name': 'Ground spraying Australia'
    },
    {
        'code': 'sw_groundsprayvineandtree',
        'name': 'Ground Spray Vine and Tree'
    },
    {
        'code': 'sw_groundsprayherbicide_pe',
        'name': 'Ground Spray Herbicide PE'
    },
    {
        'code': 'sw_groundsprayfungicide',
        'name': 'Ground Spraying Fungicide'
    },
    {
        'code': 'sw_groundsprayherbicide_ld',
        'name': 'Ground Spray Herbicide LD'
    },
    {
        'code': 'sw_groundsprayherbicide_sd',
        'name': 'Ground Spray Herbicide SD'
    },
    {
        'code': 'SW_Vixeranbiostim',
        'name': 'Vixeran Biostimulation'
    },
    {
        'code': 'SW_Ground_HLFM',
        'name': 'Ground spraying HLFM'
    }

];

export const getWeekTranslate = (translateData: IAgriAlertTranslateResModel,index:number)=>{
    let tmpWeekName = '';
    switch(index){
        case 0:
            tmpWeekName = translateData?.sun;
            break;
        case 1:
            tmpWeekName = translateData?.mon;
            break;
        case 2:
            tmpWeekName = translateData?.tue;
            break;
        case 3:
            tmpWeekName = translateData?.wed;
            break;
        case 4:
            tmpWeekName = translateData?.thu;
            break;
        case 5:
            tmpWeekName = translateData?.fri;
            break;
        case 6:
            tmpWeekName = translateData?.sat;
            break;
    }
    return tmpWeekName;
};